module.exports = __webpack_public_path__ + "static/media/blog3_big.ba0f14a5.webp";